import axios from 'axios';
import * as types from '../mutation-types';

const state = {
    activitylogs: [],
    search: '',
    page: 1,
    currentpage: 5,
    loading: false
};

const getters = {
    activitylogs: state => state.activitylogs,
    search: state => state.search,
    page: state => state.page,
    currentpage: state => state.currentpage,
    loading: state => state.loading
};
const actions = {
    async fetchActivityLogs({commit}) {
        commit(types.ACTIVITY_LOG_LOADING, true);
        let uri = `/api/activity-logs`;
        await axios.get(uri).then((response) => {
            commit(types.ACTIVITY_LOGS, response.data);
        }).catch((error) => {
            console.log(error);
        })
        commit(types.ACTIVITY_LOG_LOADING, false);
    }
};
const mutations = {
    [types.ACTIVITY_LOGS](state, data) {
        state.activitylogs = data;
    },
    [types.ACTIVITY_LOG_LOADING](state, data) {
        state.loading = data;
    },
    [types.ACTIVITY_LOG_SEARCH](state, data) {
        state.search = data;
    },
    [types.ACTIVITY_LOG_PAGE](state, data) {
        state.page = data;
    },
    [types.ACTIVITY_LOG_CURRENTPAGE](state, data) {
        state.currentpage = data;
    }
};

export {
    state, getters, actions, mutations
}
